import { render, staticRenderFns } from "./Current.vue?vue&type=template&id=8ae54272&scoped=true&"
import script from "./Current.vue?vue&type=script&lang=ts&"
export * from "./Current.vue?vue&type=script&lang=ts&"
import style0 from "./Current.vue?vue&type=style&index=0&id=8ae54272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae54272",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VImg})
